export function formatTasks (tasks: number, notation: 'standard' | 'compact') {
  return new Intl.NumberFormat('pt-BR', { notation, maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.floor(tasks))
}
